module.exports = __webpack_public_path__ + "img/img1@2x.40835cf6.png";